import { createSvgIcon } from '@mui/material';

const CheckedIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
        <path
            d="M8.99999 0.5C4.03731 0.5 -0.00012207 4.53737 -0.00012207 9.5C-0.00012207 14.4626 4.03731 18.5 8.99999 18.5C13.9626 18.5 18 14.4626 18 9.5C18 4.53737 13.9626 0.5 8.99999 0.5ZM8.99999 17.0246C4.85085 17.0246 1.47529 13.6491 1.47529 9.5C1.47529 5.35091 4.85085 1.97541 8.99999 1.97541C13.1491 1.97541 16.5246 5.35091 16.5246 9.5C16.5246 13.6491 13.1491 17.0246 8.99999 17.0246Z"
            fill="currentColor"
        />
        <path
            d="M12.8934 6.04575L7.54966 11.3895L5.1065 8.94635C4.81839 8.65829 4.35133 8.65829 4.06321 8.94635C3.77515 9.23446 3.77515 9.70152 4.06321 9.98964L7.02802 12.9544C7.09645 13.023 7.17777 13.0774 7.26729 13.1145C7.35681 13.1516 7.45277 13.1706 7.54966 13.1705C7.73846 13.1705 7.92725 13.0984 8.07131 12.9544L13.9367 7.0891C14.2247 6.80098 14.2247 6.33393 13.9367 6.04581C13.6485 5.75769 13.1814 5.75769 12.8934 6.04575Z"
            fill="currentColor"
        />
    </svg>,
    'Checked'
);

export default CheckedIcon;
